export const crmBasePath = 'crm';
export const crmPrescripteurDetail = '/crm/prescripteur';
export const crmCreatePrescripteur = '/crm/prescripteur/creer';
